import {Box, Step, StepLabel, Stepper} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import clsx from 'clsx';

const useStepperStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
    },
    title: {
        fontFamily: "Inter",
        fontWeight: "bold",
        fontSize: "x-large",
        textAlign: "center",
        margin: "40px 0",
        "&.smallMargin" : {
            margin: "15px 0",
        }
    },
    step: {
        color: "gray",
        fontSize: "medium",
    },
    icon: {
        fontSize: "large"
    }
}));

export function createStepObject(description, optional, error) {
    return {description, optional, error};
}

const AgyleStepper = (props) => {
    const classes = useStepperStyles();
    const {t} = useTranslation();

    return (
        <Box className={classes.root}>
            {props.title &&
                <div className={clsx(classes.title, props.smallMargin && 'smallMargin')}>
                    {props.title}
                </div>
            }

            <Stepper
                alternativeLabel
                activeStep={props.activeStep}
                sx={{
                    ".MuiStepConnector-root span": {
                        margin: 5
                    },
                    ".MuiSvgIcon-root": {
                        borderRadius: "50%",
                        color: "grey",
                        fontSize: 45
                    },
                    ".MuiStepIcon-text": {
                        fontWeight: 500,
                    },
                    ".MuiSvgIcon-root.Mui-active": {
                      color: '#1976d2',
                      padding: '3px',
                      borderRadius: '50%',
                      border: '1px solid #1976d2',
                      transform: `scale(${45 / 38})`,
                    },
                    ".Mui-active .MuiStepIcon-text": {
                        fill: "white",
                    },
                    ".MuiStepLabel-labelContainer span": {
                        fontSize: "large",
                    },
                }}
            >
                {props.steps.map((label, index) => (
                    <Step key={label.description}>
                        <StepLabel
                            optional={label.optional || false}
                            error={label.error || false}
                            classes={{label: classes.icon}}
                        >
                            <div className={classes.step}>
                                {t("STEP")} {index + 1}
                            </div>

                            <span style={{fontSize: props.small ? "small" : "large"}}>
                                {label.description}
                            </span>
                        </StepLabel>
                    </Step>
                ))}
            </Stepper>
        </Box>
    );
};

export default AgyleStepper;

AgyleStepper.propTypes = {
    activeStep: PropTypes.number,
    title: PropTypes.string,
    steps: PropTypes.array,
    smallMargin: PropTypes.bool,
    small: PropTypes.bool,
};

AgyleStepper.defaultProps = {
    activeStep: 0,
    title: "",
    steps: [],
    smallMargin: false,
    small: false,
};